import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RaptorModule } from '@campfire-nx/raptor';

import { RequestRoutingModule } from './request-routing.module';
import { RequestFlowComponent } from './request-flow/request-flow.component';
import { RequestFlowService } from './services/request-flow.service';

@NgModule({
  providers: [
    RequestFlowService
  ],
  declarations: [
    RequestFlowComponent
  ],
  imports: [
    CommonModule,
    RaptorModule,
    RequestRoutingModule
  ],
  exports: [
    RaptorModule
  ]
})

export class RequestModule { }
